import React from 'react';
import PropTypes from 'prop-types';
import CloseModalSvg from './CloseModalSvg';
import './Modal.sass';

const VideoModal = ({ onRequestHide, videoSrc }) => (
  <div className="home-modal not-in-range">
        <div className="home-modal-inner">
          <div className="close" onClick={onRequestHide}>
            <CloseModalSvg/>
          </div>

          <div className="home-modal-content">
            <iframe title="Promo Video" className="youtube-video" src={videoSrc} frameBorder="0" allowFullscreen></iframe>
          </div>
        </div>
      </div>
);

VideoModal.propTypes = {
  onRequestHide: PropTypes.func.isRequired,
  videoSrc: PropTypes.string.isRequired,
};

export default VideoModal;
